/** Supabase V1 refresh tokens are 12 alphanumeric chars; V2 are v1.* or long. */
export function isValidRefreshToken(token) {
  if (!token || typeof token !== 'string') return false;
  if (token === 'refreshToken' || token === 'refresh_token') return false;
  if (token.length === 12 && /^[A-Za-z0-9]+$/.test(token)) return true;
  if (token.startsWith('v1.') && token.length >= 10) return true;
  return token.length >= 20;
}

/**
 * Non-secret 8-hex fingerprint of a token: sha256(token)[0..4] as hex.
 * Safe to log — reveals nothing about the token value.
 */
export async function tokenFp(token) {
  if (!token || typeof token !== 'string') return 'none';
  try {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(token));
    return Array.from(new Uint8Array(buf).slice(0, 4))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('');
  } catch {
    return 'no-crypto';
  }
}

/**
 * Synchronous 8-char fingerprint using a simple hash (no async crypto).
 * Less secure than SHA-256 but usable in sync contexts for logging.
 */
export function tokenFpSync(token) {
  if (!token || typeof token !== 'string') return 'none';
  let h = 0x811c9dc5;
  for (let i = 0; i < token.length; i++) {
    h ^= token.charCodeAt(i);
    h = (h * 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}
